// ds-logo-slider.js
class LogoSlider extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector(".ds-logo-track");
    this.speed = parseInt(this.dataset.speed) || 30;
  }

  connectedCallback() {
    if (!this.track) {
      console.log("Track not found");
      return;
    }
    this.init();
  }

  init() {
    // Original-Items klonen
    const originalItems = Array.from(
      this.track.querySelectorAll(".ds-logo-slide")
    );

    // Genügend Klone erstellen für einen nahtlosen Scroll
    originalItems.forEach((item) => {
      const clone = item.cloneNode(true);
      this.track.appendChild(clone);
    });

    // Animation starten
    this.track.style.setProperty("--scroll-speed", `${this.speed}s`);
    this.track.classList.add("scrolling");
  }
}

customElements.define("ds-logo-slider", LogoSlider);
